// After walking OUT of a store upward, the key is often still held when the street appears, and up on the
// street walks straight back in through the same door (owner 2026-10-27). So the street ignores walking up
// until the player has walked one of the other ways: left, down-left, down, down-right or right.
// Up-left / up-right keep only their sideways half meanwhile; up alone stands still.
import { dir8FromVector } from './dir8.mjs';

const UP_DIRS = new Set([5, 6, 7]);   // up-left, up, up-right (dir8: 0 = right, 2 = down, 4 = left, 6 = up)

// One frame's movement input through the block: returns whether it still holds and what to walk.
export function applyUpBlock(blocked, dx, dy) {
  if (!blocked || (dx === 0 && dy === 0)) return { blocked, dx, dy };
  if (!UP_DIRS.has(dir8FromVector(dx, dy))) return { blocked: false, dx, dy };
  return { blocked: true, dx, dy: 0 };
}
